<template>
  <div>
    <div class="rsu pa-3 px-5">
      <div>
        <v-layout row wrap>
          <v-flex xs8>
            <div class="headline primary--text" style="position: relative; right: 20px">
              {{ editType == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ประกาศงาน
            </div></v-flex
          >
          <v-flex xs4>
            <div class="text-xs-right">
              <v-btn @click="$emit('close')" icon> <v-icon>close</v-icon></v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <uploadfile v-model="input.Logo"></uploadfile>
      </div>
      <div></div>
      <div class="mt-2">
        <div>ชื่อบริษัท</div>
        <depainput v-model="input.Name" :name="'ชื่อบริษัท'" :required="true"></depainput>
      </div>
      <div class="mt-2">
        <div>โปรไฟล์</div>
        <depainput
          :textarea="true"
          v-model="input.Profile"
          :name="'โปรไฟล์'"
          :required="true"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>ที่อยู่</div>
        <depainput v-model="input.Address" :name="'ที่อยู่'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>Lat</div>
        <depainput
          type="number"
          v-model.number="input.Lat"
          :name="'Lat'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>Long</div>
        <depainput
          type="number"
          v-model.number="input.Long"
          :name="'Long'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>เว็บไซต์</div>
        <depainput v-model="input.Website" :name="'เว็บไซต์'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>จังหวัด</div>
        <depainput v-model="input.Province" :name="'จังหวัด'" :required="true"></depainput>
      </div>
      <div class="mt-2">
        <div>รูปแบบการจ้าง</div>
        <depainput
          v-model="input.Part_Full"
          :name="'รูปแบบการจ้าง'"
          placeholder="เช่น งานประจำ, งานพาร์ทไทม์"
          :required="true"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>หมวดหมู่งาน</div>
        <depainput v-model="input.Type" :name="'หมวดหมู่งาน'" :required="true"></depainput>
      </div>
      <div class="mt-2">
        <div>จำนวนที่รับ</div>
        <depainput
          type="number"
          v-model="input.Quantity"
          :name="'จำนวนที่รับ'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>คุณสมบัติ</div>
        <depainput v-model="input.Qualifications" :name="'คุณสมบัติ'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>ความต้องการ</div>
        <depainput v-model="input.Requirements" :name="'ความต้องการ'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>ทักษะ</div>
        <depainput v-model="input.Skills" :name="'ทักษะ'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>เงินเดือน</div>
        <depainput
          :checkcash="true"
          v-model="input.Salary"
          :name="'เงินเดือน'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>ผลประโยชน์</div>
        <depainput
          :textarea="true"
          v-model="input.Benefits"
          :name="'ผลประโยชน์'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>ตำแหน่ง</div>
        <depainput v-model="input.Position" :name="'ตำแหน่ง'" :required="false"></depainput>
      </div>
      <div class="mt-2">
        <div>รายละเอียดงาน</div>
        <depainput v-model="input.Details" :name="'รายละเอียดงาน'" :required="false"></depainput>
      </div>
    </div>
    <div>
      <v-divider class="mt-3"></v-divider>
    </div>
    <div class="rsu pa-3 px-5">
      <div>
        <div
          class="headline primary--text mt-0"
          style="font-size: 19px; position: relative; right: 20px"
        >
          ช่องทางการสมัคร
        </div>
      </div>
      <div class="mt-2">
        <div>อีเมลสำหรับยื่นใบสมัคร</div>
        <depainput
          :email="true"
          v-model="input.Apply_email"
          :name="'อีเมลสำหรับยื่นใบสมัคร'"
          :required="false"
        ></depainput>
      </div>
      <div class="mt-2">
        <div>เว็บไซต์สำหรับยื่นใบสมัคร</div>
        <depainput
          v-model="input.Apply_website"
          :name="'เว็บไซต์สำหรับยื่นใบสมัคร'"
          :required="false"
        ></depainput>
      </div>
      <div class="text-xs-center my-2 mt-4">
        <v-btn @click="$emit('close')" color="primary" outline>ยกเลิก</v-btn>
        <v-btn :loading="saveloading" @click="saveData" color="primary" depressed>บันทึก</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfiletest.vue'
import depainput from '@/components/elements/depainput.vue'
import api from '@/api'
export default {
  props: ['editType', 'editData'],
  components: { uploadfile, depainput },
  data() {
    return {
      input: {
        Logo: '',
        Name: '',
        Profile: '',
        Address: '',
        Website: '',
        Province: '',
        Lat: null,
        Long: null,
        Part_Full: '',
        Type: '',
        Quantity: null,
        Qualifications: null,
        Requirements: null,
        Skills: '',
        Salary: '',
        Benefits: null,
        Contact: '',
        Apply_email: null,
        Apply_website: '',
        Position: '',
        Details: '',
        Category: ''
      },
      saveloading: false,
      allit: [
        'Database Management',
        'IT & Technical Support',
        'IT Management',
        'IT อื่นๆ',
        'Network & System',
        'Programmer & Developer',
        'SAP & ERP',
        'Website'
      ]
    }
  },
  mounted() {
    if (this.editType == 'edit') {
      this.input = { ...this.editData }
    }
  },
  methods: {
    async saveData() {
      if (await this.$validator.validate()) {
        this.saveloading = true
        if (this.editType == 'create') {
          this.onCreateData()
        } else if (this.editType == 'edit') {
          this.onEditData()
        }
      } else {
        this.$swal.fire({ type: 'error', title: 'กรุณากรอกข้อมูลให้ครบถ้วน' })
      }
    },
    onCreateData() {
      var Category = ''
      if (this.allit.includes(this.input.Type)) {
        Category = 'it'
      } else {
        Category = 'non-it'
      }
      api.postdepajobd2uadmincreatejob(
        { jobdata: [{ ...this.input, Category }] },
        (err, response) => {
          this.saveloading = false
          this.$emit('createData')
        }
      )
    },
    onEditData() {
      var Category = ''
      if (this.allit.includes(this.input.Type)) {
        Category = 'it'
      } else {
        Category = 'non-it'
      }
      var jobid = this.input._id
      var data = { ...this.input, Category }
      delete data._id
      api.putdepajobd2uadminupdatejob({ jobdata: data, jobid }, (err, response) => {
        this.saveloading = false
        this.$emit('updateData')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/jobd2u/EditData.vue